import { shouldUseSegment } from './segment.utils'
import type { SegmentProperties } from './types/segmentProperties'

export const track = (
  event: string,
  properties: Partial<SegmentProperties>,
  analytics: SegmentAnalytics.AnalyticsJS,
): void => {
  if (shouldUseSegment(analytics)) {
    analytics.track(event, properties)
  }
}
